import React from 'react';
import './Tours.css';
import Navbar from './Navbar';
import Footer from './Footer';

const Tours = () => {
  return (
    <>
      <Navbar />
      <main className="tours-container">
        <header className="tours-header">
          <h1>Industrial Visit to JSW Bellary</h1>
          <p className="tours-subtext">On Invitation Basis</p>
        </header>

        <section className="tours-section">
          <div className="industrial-visit-card">
            <div className="visit-timings">
              <h2>Timings:</h2>
              
              <div className="timing-block">
                <h3>Departure from IISc Campus:</h3>
                <p><strong>Date:</strong> 12th December 2025</p>
                <p><strong>Start:</strong> 6:30 AM - 7:30 AM</p>
              </div>

              <div className="timing-block">
                <h3>Return to IISc Campus:</h3>
                <p><strong>Date:</strong> 13th December 2025</p>
                <p><strong>Return:</strong> 7:30 PM - 8:00 PM</p>
              </div>

              <div className="starting-point">
                <p><strong>Starting Point:</strong> IISc Main Building</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <br />
      <br />
      <Footer />
    </>
  );
};

export default Tours;
